<template>
    <b-modal
        id="tips-overview-modal"
        modal-class="apprentice-default-modal"
        :title="$t('magazine.tips_overview')"
        size="md"
        ok-only
        :ok-title="$t('common.close')"
        ok-variant="primary">
        <div class="tips-list">
            <b-list-group>
                <b-list-group-item
                    class="tip-item"
                    v-for="tip of tipsIn"
                    :key="tip.id">
                    <b-media class="magazine-tip-of-the-day">
                        <template #aside>
                            <b-img src="/images/ellen.png"></b-img>
                            <div class="name">Ellen's tip:</div>
                        </template>
                        <h5 class="tip-of-the-day-title">{{ tip.title }}</h5>
                        <p class="tip-of-the-day-body">{{ tip.value }}</p>
                    </b-media>
                </b-list-group-item>
            </b-list-group>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-magazine-pageoverview-tips-overview-modal-component',
    props: {
        tipsIn: {
            type: Array,
            required: true,
        },
    },
};
</script>

<style scoped lang="scss">
.tips-list {
    max-height: 650px;
    overflow: auto;

    .list-group {
        padding-right: map-get($grid-gutter-spacing, 'ten');
    }
}

.tip-item {
    display: flex;
    align-items: stretch;
    padding: 0;
    border: 1px solid $border-color;
    margin-bottom: $grid-gutter-width;
    border-radius: 8px;

    .magazine-tip-of-the-day {
        position: relative;
        padding: map-get($grid-gutter-spacing, 'ten');
        background-color: $white;
        border-radius: $border-radius-content;
        box-shadow: 3px 4px 15px 0 #cccece38;
        animation: slide-in steps(30) 0.8s 1;
        width: 100%;

        .media-aside {
            flex-direction: column;
            justify-content: center !important;

            img {
                width: 40px;
                height: 40px;
                align-self: center;
            }

            .name {
                color: $primary;
                font-weight: $font-weight-medium;
            }
        }

        .tip-of-the-day-title {
            font-weight: $font-weight-medium;
            margin-bottom: 0;
        }

        .tip-of-the-day-body {
            color: $text-muted-color;
        }
    }
}
</style>
